import css from './index.module.scss';
import { EFSupportLeft } from '@/components/UI/svg/Support';
import { useGlobal } from '@/utils/useGlobal';

export default function SupportTile({ title, lang, content = null }: any) {
    const { Link, useRouter } = useGlobal();
    const { locale } = useRouter();

    return (
        <div className={`${css.accessoriesType}  accessoriesType ${content ? 'hasContent' : ''}`}>
            <h3>
                <EFSupportLeft className="supportIcon" />
                <span className="word font-family-semibold">{title}</span>
            </h3>
            {['uk', 'de', 'fr', 'es', 'it', 'eu', 'au'].includes(locale as string) && lang?.date1 && lang?.date2 && (
                <div className="policy-date">
                    <span className="date-item">{lang?.date1}</span>
                    <span className="date-item">{lang?.date2}</span>
                </div>
            )}
            {content?.text && (
                <div className="content">
                    <Link href={content?.link} className={'content-text'}>
                        {content?.text}
                        {' >'}
                    </Link>
                </div>
            )}
        </div>
    );
}
